<template>
  <v-layout wrap>
    <!-- bio -->
    <v-flex xs12 class="">
     <bio></bio>
    </v-flex>
    <!-- bio -->
    
    <!-- dashboard -->
    <v-flex xs12 class="mt-3 mb-2">
      <sidebar-dashboard></sidebar-dashboard>
    </v-flex>
    <!-- end of dashboard -->
  </v-layout>
</template>

<script>
import SidebarDashboard from "@/components/expert_sidebar/_partials/dashboard.vue";
import Bio from "@/components/expert_sidebar/_partials/bio.vue";
import { mapGetters } from "vuex";
export default {
  name: "Sidebar",
  components: {
    SidebarDashboard,
    Bio
  },
  computed: {
    avatarSize() {
      return `156px`;
    },
    ...mapGetters(["user"])
  }
};
</script>

<style scoped>
.avatar {
  background-color: #fff;
}
</style>
